import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Camera, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { upload, errMsg } from "@/lib/api";
import { captureCurrent } from "@/lib/capture";

export const CaptureButton = () => {
  const { user } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  if (user?.role !== "admin" || window.self !== window.top || /^\/(meet|login)/.test(window.location.pathname)) return null;
  const go = async () => {
    setBusy(true);
    try {
      const blob = await captureCurrent();
      const w = window.innerWidth, vp = w < 640 ? "mobile" : w < 1024 ? "tablet" : "desktop";
      const fd = new FormData();
      fd.append("file", blob, "screen.png"); fd.append("title", document.title.split("|")[0].trim() || window.location.pathname); fd.append("route", window.location.pathname);
      fd.append("viewport", vp); fd.append("width", w); fd.append("height", window.innerHeight); fd.append("role", user.role); fd.append("source", "button");
      const { data } = await upload("/api/academy/shots", fd);
      toast.success("Screen captured (personal data masked) — opening the editor");
      nav(`/admin/training-shots?edit=${data.id}`);
    } catch (e) { toast.error(errMsg(e, "Capture failed")); } finally { setBusy(false); }
  };
  return (
    <button data-no-capture onClick={go} disabled={busy} className="fixed bottom-4 left-4 z-[60] h-10 px-4 rounded-full bg-slate-900/90 hover:bg-slate-900 text-white text-xs font-bold shadow-lg flex items-center gap-2 backdrop-blur print:hidden" data-testid="capture-screen-btn">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Camera className="w-4 h-4" />}Capture this screen for training
    </button>
  );
};
